import Alert from '@material-ui/lab/Alert';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    errorMessageContainer: {
        marginTop: '1em',
        [theme.breakpoints.up('md')]: {
            maxWidth: 500,
        }
    }
}))

const SelfGiftingCheckoutError = ({open}) => {
    const classes = useStyles();
    if (!open) {
        return <></>
    }
    return (
        <Alert severity="error" className={classes.errorMessageContainer}>
            When sending a gift to yourself, you are limited to $100. Please reduce your order total to proceed.
        </Alert>
    )
}
export default SelfGiftingCheckoutError;